import Vue from "vue";

const f = (el, { value }) => {
  if (el.clientWidth) {
    el.style.height = el.clientWidth / value + "px";
  } else {
    el.style.opacity = "0";

    let interval = setInterval(() => {
      if (el.clientWidth) clearInterval(interval);

      el.style.height = el.clientWidth / value + "px";
      el.style.opacity = "1";
    }, 100);
  }
};

Vue.directive("responsive", {
  inserted: f,
  update: f
});
